import { Button, Form, Input, Select, Table } from 'antd'
import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import styles from './index.module.less'
import _, { cloneDeep, isArray, isEmpty, isNumber, uniqueId } from 'lodash'
import tagsMap from '../../utils'
import { SAlert } from 'shj-components'
const { TextArea } = Input
interface IProps {
  submitData: any // 商品提交信息
  spaceId: string // 当前空间id
  type: string
  loading: boolean
  selectedRowKeys: any
  setSelectedRowKeys: any
}
export default forwardRef(function SubSpaceApply(porps: IProps, ref) {
  const {
    submitData,
    spaceId,
    type,
    loading = false,
    selectedRowKeys = [],
    setSelectedRowKeys = () => ({}),
    setSubPriceAll = () => ({}),
  } = porps
  const [form] = Form.useForm()
  const [columns, setColumns] = useState<any>([])
  const [newSpaceData, setNewSpaceData] = useState<any>([])
  const dataRef = useRef<any>([])
  dataRef.current = newSpaceData.list
  useEffect(() => {
    let columns: any = []
    if (type === 'SUB') {
      columns = [
        {
          title: '序号',
          dataIndex: 'key',
          width: 100,
          render: (text, record, index) => index + 1,
        },
        {
          title: '项目类型',
          dataIndex: 'typeNameList',
          width: 100,
          render: (text, record) => {
            text = text?.map((str: string) => (
              <div
                key={str}
                className={'normal_tag_style'}
                style={{
                  color: tagsMap[str]?.color,
                  backgroundColor: tagsMap[str]?.bgColor,
                  marginRight: '8px',
                }}
              >
                {tagsMap[str]?.name}
              </div>
            ))
            return <div>{text}</div>
          },
        },
        {
          title: '应用空间',
          dataIndex: 'itemId',
          width: 120,
          render: (text, record, index) => <div>{record?.budgetItemList[0]?.showName}</div>,
        },
        {
          title: '最大可减量',
          dataIndex: 'availableQuantity',
          width: 100,
          align: 'right',
        },
        {
          title: (
            <span>
              <span style={{ color: 'red' }}>*</span>预算量计算式
            </span>
          ),
          dataIndex: 'budgetQtyFormular',
          width: 100,
          render: (text, record, index) => (
            <div>
              <Form.Item>
                <Input
                  disabled={
                    newSpaceData.errMessage || !selectedRowKeys?.includes(record?.referenceId)
                  }
                  onChange={e => {
                    onChangeCalculate(index, e.target.value)
                  }}
                ></Input>
              </Form.Item>
            </div>
          ),
        },
        {
          title: '预算量',
          dataIndex: 'budgetQtyValue',
          width: 100,
          render: (text, record, index) => {
            if (text === false) {
              text = '计算式错误'
            }
            return (
              <div>
                <Form.Item>
                  <Input disabled value={text}></Input>
                </Form.Item>
              </div>
            )
          },
        },
        // {
        //   title: '单位',
        //   dataIndex: 'unitName',
        //   width: 80,
        //   ellipsis: {
        //     showTitle: true,
        //   },
        // },
        {
          title: '单价',
          dataIndex: 'saleCustPrice',
          align: 'right',
          width: 100,
          render: (text, record, index) => {
            return (
              <span>
                ￥{text || 0}
                {record.unitName ? '/' + record.unitName : ''}
              </span>
            )
          },
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 100,
          render: (text, record, index) => (
            <div>
              <Form.Item>
                <TextArea
                  autoSize
                  disabled={
                    newSpaceData.errMessage || !selectedRowKeys?.includes(record?.referenceId)
                  }
                  value={text}
                  maxLength={255}
                  onChange={e => {
                    let list: any = dataRef?.current || []
                    const newData = _.cloneDeep(list)
                    newData[index].remark = e.target.value
                    setNewSpaceData({ ...newSpaceData, list: newData })
                  }}
                ></TextArea>
              </Form.Item>
            </div>
          ),
        },
      ]
      setColumns([...columns])
    }
  }, [selectedRowKeys, newSpaceData])
  useEffect(() => {
    console.log(submitData?.list, spaceId)

    let item = submitData?.list?.find((item: any) => item?.spaceId === spaceId)
    setSelectedRowKeys([item?.referenceId || submitData?.list?.[0]?.referenceId])
    setNewSpaceData({ ...submitData })
  }, [submitData])
  useMemo(() => {
    let prevNum = 0
    newSpaceData?.list?.forEach(item => {
      if (item?.budgetQtyValue && isNumber(item?.budgetQtyValue)) {
        prevNum += item?.budgetQtyValue * item?.saleCustPrice
      }
    })
    setSubPriceAll(prevNum)
  }, [newSpaceData])

  const onChangeCalculate = (index, val) => {
    let list: any = dataRef?.current || []
    if (val) {
      let funcRes: any = ''
      try {
        const func = new Function(`return ${val}`)
        funcRes = func()
      } catch (err) {
        funcRes = false
      }
      funcRes = typeof funcRes === 'number' ? Number(funcRes.toFixed(4)) : funcRes
      console.log(funcRes)
      const newData = _.cloneDeep(list)
      console.log(newData, 'newData22222222222')

      newData[index].budgetQtyFormular = val
      newData[index].budgetQtyValue = funcRes

      setNewSpaceData({ ...newSpaceData, list: newData })
    }
  }

  useImperativeHandle(ref, () => ({
    spaceData: dataRef.current?.filter((item: any) => selectedRowKeys.includes(item?.referenceId)),
  }))
  const onSelectChange = (newSelectedRowKeys: any) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys)
    setSelectedRowKeys(newSelectedRowKeys)
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  }
  return (
    <div className={styles.spaceApplyBox}>
      <div>
        <div style={{ fontSize: '14px', fontWeight: 600, color: '#2D2D2E', marginTop: 12 }}>
          应用空间
        </div>

        <div style={{ marginBottom: 12, marginTop: 12 }}>
          <SAlert type="info">
            该商品共应用到了以下空间，请选择需要减去商品的空间，并设置预算量，预算量需小于0
          </SAlert>
        </div>
        <Table
          rowClassName={() => 'editable-row'}
          rowKey={record => record?.referenceId}
          dataSource={dataRef.current}
          columns={columns}
          pagination={false}
          rowSelection={rowSelection}
          loading={loading}
        />
      </div>
    </div>
  )
})
